import { make } from 'vuex-pathify';
import { state as initialState } from '@/store/autoSubscribe';

const getters = {
  ...make.getters(initialState),
};

export { getters };
